/**
 *
 * @param {number} x
 * @param {string} separator
 * @returns {string}
 */
export function thousandsSeparator(x, separator = ',') {
  if (typeof x !== 'number') throw new TypeError('"thousandsSeparator()" accepts only numbers');
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
}

export default thousandsSeparator;
